import './zod-setup';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from '@/app/providers/app-providers';
import { createAppRouter } from '@/app/router';
import { createAppRuntime } from '@/app/runtime';
import '@batiflow/ui/fonts/latin.css';
import './index.css';

const runtime = createAppRuntime();
runtime.errorReporter.install(window);
const router = createAppRouter();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

// The first render needs the translations of the language in use (loaded on demand).
await runtime.i18nReady;

createRoot(container).render(
  <StrictMode>
    <AppProviders runtime={runtime}>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
